// Tabelle canone concordato — Accordo territoriale Firenze e comuni limitrofi
// sottoscritto il 03/07/2025, in vigore dal 07/07/2025.
// Valori MASSIMI in €/mq mensili per tipologia (A/B/C). Fonte: accordo ufficiale, Comune di Firenze.
export const ACCORDO = {
  firenze: {
    nome: "Firenze",
    zone: [
      { id: "centro", nome: "Centro storico, Lungarno, Piazza Ferrucci", A: 13.0, B: 11.0, C: 7.0 },
      { id: "pregio", nome: "Zona di pregio: Bobolino, Due Strade, Marignolle, Careggi, Settignano", A: 13.5, B: 12.0, C: 7.5 },
      { id: "intermedia-a", nome: "Intermedia A: Campo di Marte, Novoli, Cure, Coverciano, Rovezzano", A: 10.2, B: 9.0, C: 5.5 },
      { id: "intermedia-b", nome: "Intermedia B: San Jacopino, Dalmazia, Cascine, Galluzzo", A: 9.7, B: 8.7, C: 5.5 },
      { id: "periferica-a", nome: "Periferica A: Legnaia, Isolotto, Argingrosso, Castello", A: 9.2, B: 8.3, C: 5.5 },
      { id: "periferica-b", nome: "Periferica B: Piagge, Peretola, Mantignano, Cupolina", A: 8.75, B: 8.1, C: 5.0 },
    ],
  },
  scandicci: {
    nome: "Scandicci",
    zone: [
      { id: "centro", nome: "Centro: Comune Vecchio e Nuovo, via Roma, Corbinaie, Mercato", A: 10.0, B: 8.8, C: 6.5 },
      { id: "collina", nome: "Collina: San Martino alla Palma, Mosciano, Giogoli, Scandicci Alto", A: 11.5, B: 10.0, C: 7.0 },
      { id: "nord", nome: "Nord: Casellina, Vingone, Badia a Settimo, Olmo, Granatieri", A: 9.2, B: 8.0, C: 6.0 },
    ],
  },
  "lastra-a-signa": {
    nome: "Lastra a Signa",
    zone: [
      { id: "periferica", nome: "Periferica: Brucianesi, Porto di Mezzo, Ponte a Signa Basso", A: 8.3, B: 6.9, C: 5.6 },
      { id: "centro", nome: "Centro storico, Ginestra Fiorentina, Malmantile, Ponte a Signa Alto", A: 8.5, B: 7.1, C: 5.7 },
      { id: "pregio", nome: "Intermedia e di pregio: Collinare, Natività, Stadio Vecchio", A: 8.5, B: 7.1, C: 5.7 },
    ],
  },
  signa: {
    nome: "Signa",
    zone: [
      { id: "periferica", nome: "Zona agricola e periferica", A: 7.7, B: 6.3, C: 5.1 },
      { id: "centro", nome: "Zona centro edificato", A: 8.1, B: 6.8, C: 5.6 },
      { id: "intermedia", nome: "Zona intermedia", A: 8.6, B: 7.4, C: 5.7 },
    ],
  },
  "campi-bisenzio": {
    nome: "Campi Bisenzio",
    zone: [
      { id: "periferica", nome: "Agricola e periferica: San Angelo a Lecore, Indicatore", A: 8.0, B: 7.0, C: 6.0 },
      { id: "frazioni", nome: "Frazioni: San Donnino, Il Rosi", A: 8.8, B: 7.8, C: 6.0 },
      { id: "centro", nome: "Centrale: Capoluogo, San Martino, La Villa, Capalle, San Piero a Ponti", A: 9.4, B: 8.4, C: 6.5 },
    ],
  },
  "sesto-fiorentino": {
    nome: "Sesto Fiorentino",
    zone: [
      { id: "periferica", nome: "Periferica sud e commerciale", A: 9.0, B: 7.8, C: 6.0 },
      { id: "centro", nome: "Zona centrale ed extraurbana", A: 10.3, B: 8.7, C: 6.5 },
      { id: "pregio", nome: "Zona di pregio", A: 11.5, B: 10.0, C: 7.0 },
    ],
  },
};

export const TIPOLOGIE = [
  {
    id: "A",
    nome: "Tipologia A — recente o ristrutturato",
    descr: "Costruito o ristrutturato negli ultimi 10 anni, impianti ammodernati, infissi nuovi, efficienza energetica",
  },
  {
    id: "B",
    nome: "Tipologia B — buono stato",
    descr: "Impianti a norma, riscaldamento efficiente, infissi e dotazioni adeguate",
  },
  {
    id: "C",
    nome: "Tipologia C — da migliorare",
    descr: "Non raggiunge i requisiti della tipologia B, ma è conforme alla normativa",
  },
];

// Maggiorazioni previste dall'accordo (art. 9 e 11)
export const ARREDO = [
  { id: "no", nome: "Non arredato", pct: 0 },
  { id: "parziale", nome: "Parzialmente arredato (+10%)", pct: 0.10 },
  { id: "completo", nome: "Completamente arredato (+15%)", pct: 0.15 },
];

export const APE = [
  { id: "gf", nome: "Classe G o F (nessuna maggiorazione)", pct: 0 },
  { id: "e", nome: "Classe E (+2%)", pct: 0.02 },
  { id: "d", nome: "Classe D (+4%)", pct: 0.04 },
  { id: "c", nome: "Classe C (+6%)", pct: 0.06 },
  { id: "b", nome: "Classe B (+8%)", pct: 0.08 },
  { id: "a", nome: "Classe A (+10% minimo)", pct: 0.10 },
];

export const DURATA = [
  { id: "3+2", nome: "3 anni + 2 (durata base)", pct: 0 },
  { id: "4+2", nome: "4 anni + 2 (+4,5%)", pct: 0.045 },
  { id: "5+2", nome: "5 anni + 2 (+6%)", pct: 0.06 },
];
